import { useState } from 'react';
import { Modal, message } from 'antd';
import { useAppContext } from '@/components/AppContext';
import { CreateStore } from '@a4b/api/src/modules/Monetisation/Puja/types';
import { openErrorNotification } from '@/utils';
import { showErrorToast } from '@/utils/helper';

interface StoreActivationModalProps {
    visible: boolean;
    isActivate: boolean;
    currentItem?: Partial<CreateStore>;
    onCancel: () => void;
    onSuccess: () => void;
}

const StoreActivationModal = ({
    visible,
    isActivate,
    currentItem,
    onCancel,
    onSuccess,
}: StoreActivationModalProps) => {
    const { networkInstance, languageState, countryState } = useAppContext();
    const { monetisationPujaApi } = networkInstance.clientWithHeaders;

    const [loading, setLoading] = useState(false);

    const handleOk = async () => {
        // if (isActivate && !selectedPage) {
        //     message.error('Please select a page');
        //     return;
        // }

        if (!currentItem?.id) {
            message.error('Store ID is missing');
            return;
        }

        setLoading(true);
        try {
            // First update store status
            const statusPayload = {
                active: !currentItem.active,
                language_code: languageState.monetisationLanguage,
                country_code: countryState?.countryCode,
            };

            await monetisationPujaApi.storesApi.updateStoreStatus(
                currentItem.id,
                statusPayload
            );

            // // Only add store to page if we're activating
            // if (isActivate && selectedPage) {
            //     await monetisationPujaApi.pageInfoApi.addStoreToPage(selectedPage, currentItem.id);
            // }

            message.success({
                content: 'Store status updated successfully',
                duration: 3,
                key: 'update_status',
            });

            onSuccess();
        } catch (error) {
            console.error('Error updating store:', error);
            //openErrorNotification(error)
            showErrorToast(error)

        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            title={isActivate ? 'Activate Store' : 'Deactivate Store'}
            visible={visible}
            onOk={handleOk}
            onCancel={onCancel}
            okText={isActivate ? 'Yes, Activate' : 'Yes, Deactivate'}
            confirmLoading={loading}
        >
            <p>Are you sure to {isActivate ? 'activate' : 'deactivate'} this store?</p>
            {/* {isActivate && (
                <div style={{ marginTop: 16 }}>
                    <p>Select a page to add this store:</p>
                    <Select
                        style={{ width: '100%' }}
                        placeholder="Select a page"
                        value={selectedPage}
                        onChange={setSelectedPage}
                        options={pages.map(page => ({
                            label: page.name,
                            value: page.id
                        }))}
                        loading={pagesLoading}
                    />
                </div>
            )} */}
        </Modal>
    );
};

export default StoreActivationModal; 